import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { recipes } from "../../sdk/utils/api";

export interface IUseDeleteRecipeMutationParameters {
    id: string;
}

export const useDeleteRecipe = (
    invalidQueryKeys: string | string[],
): UseMutationResult<void, unknown, IUseDeleteRecipeMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<void, unknown, IUseDeleteRecipeMutationParameters>({
        mutationFn: (parameters: IUseDeleteRecipeMutationParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot delete recipe without authorization token.",
                );
            }

            return recipes.Recipe.delete({ ...parameters, token: auth.token });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
